export type KeyboardActionOrder = "default" | "swapped";

const KEY = "mk:keyboard-action-order";

export function getStoredKeyboardActionOrder(): KeyboardActionOrder {
  return localStorage.getItem(KEY) === "swapped" ? "swapped" : "default";
}

export function storeKeyboardActionOrder(order: KeyboardActionOrder): void {
  if (order === "swapped") {
    localStorage.setItem(KEY, order);
  } else {
    localStorage.removeItem(KEY);
  }
}

/** Harfleri bozmadan yalnız Enter ve Sil tuşlarının yerlerini değiştirir. */
export function keyboardRowsForActionOrder(
  rows: readonly (readonly string[])[],
  order: KeyboardActionOrder,
): readonly (readonly string[])[] {
  if (order === "default") return rows;

  return rows.map((row) =>
    row.map((key) => {
      if (key === "ENTER") return "BACKSPACE";
      if (key === "BACKSPACE") return "ENTER";
      return key;
    })
  );
}
